import { useEffect } from 'react'

import { attemptTokenRefresh } from 'shared/api/auth/attemptTokenRefresh'
import { subscribeToAuthChannel } from 'shared/services/authSocket'
import { logger } from 'shared/services/logger'

import { useUserContext } from './useUserContext'

// listen to user token change channel and attempt refreshing the token
// when the current token is invalidated.
export const useTokenRefreshSocket = () => {
  const { user } = useUserContext()
  const userId = user?.id

  useEffect(() => {
    if (!userId) {
      return
    }

    return subscribeToAuthChannel(
      `private-users.${userId}.token`,
      eventName => {
        logger.track('auth.token_invalidated_by_socket', { event: eventName })
        attemptTokenRefresh()
      }
    )
  }, [userId])
}
